<script setup lang="ts">
import {computed} from 'vue';
import {readField} from '@/crm/odata';

interface IProps {
    note: any;
}

const props = defineProps<IProps>();

const subject = computed(() => readField(props.note, 'subject') ?? '');
const body = computed(() => readField(props.note, 'notetext') ?? '');
const modifiedOn = computed(() => readField(props.note, 'modifiedon') ?? '');
const modifiedBy = computed(() => readField(props.note, 'modifiedby.fullname') ?? '');
</script>

<template>
    <article class="note-card">
        <div class="meta-row"><span class="meta-label">Modified By</span><span class="modified-by">{{ modifiedBy || '—' }}</span></div>
        <div class="meta-row"><span class="meta-label">Modified On</span><span class="modified-on">{{ modifiedOn }}</span></div>
        <div v-if="subject" class="subject">{{ subject }}</div>
        <div v-if="body" class="body">{{ body }}</div>
    </article>
</template>

<style scoped>
.note-card {
    background: var(--color-background-bright);
    border: 1px solid var(--color-border, rgba(0, 0, 0, 0.08));
    border-radius: 0.5rem;
    padding: 0.75rem 1rem;
    margin-bottom: 0.75rem;
}

.meta-row {
    display: flex;
    gap: 0.4rem;
    align-items: baseline;
    font-size: var(--font-size-body);
    color: var(--color-text);
}

.meta-label {
    opacity: 0.6;
}

.modified-by {
    font-weight: 600;
}

.modified-on {
    font-size: 0.85rem;
    opacity: 0.75;
}

.subject {
    margin-top: 0.5rem;
    font-weight: 600;
    font-size: var(--font-size-body);
    color: var(--color-text);
    margin-bottom: 0.25rem;
}

.body {
    font-size: var(--font-size-body);
    color: var(--color-text);
    white-space: pre-wrap;
    word-break: break-word;
}
</style>
